import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
import { rmaRequest } from './queryKeys';
const useUpdateRmaRequest = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.patch(`${envVars.API_COMMERCE_HOSTNAME}rma/request/`, attributes, params),
        onSuccess: (response) => {
            queryClient.invalidateQueries({
                queryKey: [rmaRequest, response?.data?.id]
            });
        }
    });
};
export default useUpdateRmaRequest;
